/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  triggerEmailOtp,
  triggerMobileOtp,
  verifyEmailOtp,
  verifyMobileOtp,
} from '../../../redux/slices/accountInfoSlice/actions';

import styles from './Account.module.scss';

function Account() {
  const dispatch = useDispatch();
  const { authUser } = useSelector((state) => ({
    isAuthenticated: state?.auth?.isAuthenticated,
    authUser: state?.auth?.authUser,
  }));
  const [formState, setFormState] = useState({
    email: '',
    mobile: '',
  });
  const [otpRequested, setOtpRequested] = useState({
    email: false,
    mobile: false,
  });
  const [otp, setOtp] = useState({
    email: '',
    mobile: '',
  });
  const [otpSent, setOtpSent] = useState({
    email: false,
    mobile: false,
  });
  const [otpVerified, setOtpVerified] = useState({
    email: false,
    mobile: false,
  });
  const [errors, setErrors] = useState({
    email: '',
    mobile: '',
  });
  const [otpErrors, setOtpErrors] = useState({
    email: '',
    mobile: '',
  });

  const emailValidator = () => {
    if (
      /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i.test(
        formState?.email,
      )
    ) {
      return true;
    }
    return false;
  };

  const validateFields = (name, value) => {
    let error = null;

    switch (name.toLowerCase()) {
      case 'email':
        if (value?.length === 0 || !emailValidator()) {
          error = 'Please Enter Valid Email';
        }
        break;
      case 'mobile':
        if (value?.length < 10) {
          error = 'Please Enter Valid Mobile Number';
        }
        break;
      default:
        error = null;
    }

    return error;
  };

  const requestOtp = async (action) => {
    if (action === 'email') {
      const fieldError = validateFields('email', formState?.email);

      if (fieldError) {
        setErrors((errorState) => ({
          ...errorState,
          email: fieldError,
        }));
      } else {
        const res = await dispatch(triggerEmailOtp(formState?.email)).unwrap();
        if (res?.success) {
          setOtpRequested((prevState) => ({
            ...prevState,
            email: true,
          }));
          setOtpSent((prevState) => ({
            ...prevState,
            email: !prevState.email,
          }));
        } else {
          setErrors((errorState) => ({
            ...errorState,
            email: res?.message,
          }));
        }
      }
    } else if (action === 'mobile') {
      const fieldError = validateFields('mobile', formState?.mobile);

      if (fieldError) {
        setErrors((errorState) => ({
          ...errorState,
          mobile: fieldError,
        }));
      } else {
        const res = await dispatch(triggerMobileOtp(formState?.mobile)).unwrap();
        if (res?.success) {
          setOtpRequested((prevState) => ({
            ...prevState,
            mobile: true,
          }));
          setOtpSent((prevState) => ({
            ...prevState,
            mobile: !prevState.mobile,
          }));
        } else {
          setErrors((errorState) => ({
            ...errorState,
            mobile: res?.message,
          }));
        }
      }
    }
  };

  const onEditClick = async (action) => {
    if (action === 'email') {
      setOtpRequested((prevState) => ({
        ...prevState,
        email: !prevState.email,
      }));
      setOtpSent((prevState) => ({
        ...prevState,
        email: !prevState.email,
      }));
    } else if (action === 'mobile') {
      setOtpRequested((prevState) => ({
        ...prevState,
        mobile: !prevState.mobile,
      }));
      setOtpSent((prevState) => ({
        ...prevState,
        mobile: !prevState.mobile,
      }));
    }
  };

  const onVerifyClick = async (action) => {
    if (action === 'email') {
      const res = await dispatch(verifyEmailOtp({ email: formState?.email, otp: otp?.email })).unwrap();
      if (res?.success) {
        setOtpSent((prevState) => ({
          ...prevState,
          email: false,
        }));
        setOtpVerified((prevState) => ({
          ...prevState,
          email: true,
        }));
      } else {
        setOtpErrors((errorState) => ({
          ...errorState,
          email: res?.message,
        }));
      }
    } else if (action === 'mobile') {
      const res = await dispatch(verifyMobileOtp({ mobile: formState?.mobile, otp: otp?.mobile })).unwrap();
      if (res?.success) {
        setOtpSent((prevState) => ({
          ...prevState,
          mobile: false,
        }));
        setOtpVerified((prevState) => ({
          ...prevState,
          mobile: true,
        }));
      } else {
        setOtpErrors((errorState) => ({
          ...errorState,
          mobile: res?.message,
        }));
      }
    }
  };

  const onUpdateClick = (action) => {
    setFormState((prevState) => ({
      ...prevState,
      email: action === 'email' ? '' : prevState?.email,
      mobile: action === 'mobile' ? '' : prevState?.mobile,
    }));

    setOtpRequested((prevState) => ({
      ...prevState,
      email: action === 'email' ? '' : prevState?.email,
      mobile: action === 'mobile' ? '' : prevState?.mobile,
    }));

    setOtp((prevState) => ({
      ...prevState,
      email: action === 'email' ? '' : prevState?.email,
      mobile: action === 'mobile' ? '' : prevState?.mobile,
    }));

    setOtpSent((prevState) => ({
      ...prevState,
      email: action === 'email' ? '' : prevState?.email,
      mobile: action === 'mobile' ? '' : prevState?.mobile,
    }));

    setOtpVerified((prevState) => ({
      ...prevState,
      email: action === 'email' ? '' : prevState?.email,
      mobile: action === 'mobile' ? '' : prevState?.mobile,
    }));

    setErrors((prevState) => ({
      ...prevState,
      email: action === 'email' ? '' : prevState?.email,
      mobile: action === 'mobile' ? '' : prevState?.mobile,
    }));
  };

  useEffect(() => {
    if (authUser) {
      setFormState((prevState) => ({
        ...prevState,
        email: authUser?.email,
        mobile: authUser?.mobile_number || authUser?.mobileNumber,
      }));
      setOtpRequested((prevState) => ({
        ...prevState,
        email: true,
        mobile: true,
      }));
      setOtpSent((prevState) => ({
        ...prevState,
        email: false,
        mobile: false,
      }));
      setOtpVerified((prevState) => ({
        ...prevState,
        email: true,
        mobile: true,
      }));
    }
  }, [authUser]);

  return (
    <div className={styles.accountWrapper}>
      {/* Email Section */}
      <div className={styles.formLabel}>Email</div>
      <div className={styles.formWrapper}>
        <div>
          <input
            type="text"
            id="your-name"
            onChange={(e) => {
              setFormState((prevState) => ({
                ...prevState,
                email: e.target.value,
              }));
              setErrors((errorState) => ({
                ...errorState,
                email: '',
              }));
            }}
            value={formState?.email}
            className={`${styles.formInput} ${otpRequested?.email ? styles.formInputActive : ''}`}
            placeholder="Enter your Email"
            disabled={otpRequested?.email}
          />
          {errors?.email && <div className={styles?.errorMsg}>{errors?.email}</div>}
        </div>
        {!otpRequested?.email && !otpVerified?.email && (
          <div className={styles.btn} onClick={() => requestOtp('email')}>
            Request Otp
          </div>
        )}
        {otpRequested?.email && !otpVerified?.email && (
          <div className={styles.btn} onClick={() => onEditClick('email')}>
            Edit
          </div>
        )}
        {otpVerified?.email && (
          <div className={styles.btn} onClick={() => onUpdateClick('email')}>
            Update
          </div>
        )}
      </div>

      {/* OTP Email Section */}
      {otpSent?.email && (
        <>
          <div className={styles.formLabel}>Enter OTP</div>
          <div className={styles.formWrapper}>
            <div>
              <input
                type="tel"
                maxLength={6}
                id="your-name"
                onChange={(e) => {
                  const numericValue = e.target.value.replace(/[^0-9]/g, ''); // Allow only numeric characters
                  setOtp((prevState) => ({
                    ...prevState,
                    email: numericValue,
                  }));
                  setOtpErrors((errorState) => ({
                    ...errorState,
                    email: '',
                  }));
                }}
                value={otp?.email}
                className={styles.formInput}
                placeholder="Enter OTP"
              />
              {otpErrors?.email && <div className={styles?.errorMsg}>{otpErrors?.email}</div>}
            </div>
            <div className={styles.btn} onClick={() => onVerifyClick('email')}>
              Verify
            </div>
          </div>
        </>
      )}

      {/* Mobile Section */}
      <div className={styles.formLabel}>Mobile Number</div>
      <div className={styles.formWrapper}>
        <div>
          <input
            type="tel"
            maxLength={10}
            id="mobile"
            onChange={(e) => {
              const numericValue = e.target.value.replace(/[^0-9]/g, ''); // Allow only numeric characters
              setFormState((prevState) => ({
                ...prevState,
                mobile: numericValue,
              }));
              setErrors((prevError) => ({
                ...prevError,
                mobile: '',
              }));
            }}
            value={formState?.mobile}
            className={`${styles.formInput} ${otpRequested?.mobile ? styles.formInputActive : ''}`}
            placeholder="Enter your Mobile"
            disabled={otpRequested?.mobile}
          />
          {errors?.mobile && <div className={styles?.errorMsg}>{errors?.mobile}</div>}
        </div>
        {!otpRequested?.mobile && !otpVerified?.mobile && (
          <div className={styles.btn} onClick={() => requestOtp('mobile')}>
            Request Otp
          </div>
        )}
        {otpRequested?.mobile && !otpVerified?.mobile && (
          <div className={styles.btn} onClick={() => onEditClick('mobile')}>
            Edit
          </div>
        )}
        {otpVerified?.mobile && (
          <div className={styles.btn} onClick={() => onUpdateClick('mobile')}>
            Update
          </div>
        )}
      </div>

      {/* OTP Mobile Section */}
      {otpSent?.mobile && (
        <>
          <div className={styles.formLabel}>Enter OTP</div>
          <div className={styles.formWrapper}>
            <div>
              <input
                type="tel"
                maxLength={6}
                id="your-name"
                onChange={(e) => {
                  const numericValue = e.target.value.replace(/[^0-9]/g, ''); // Allow only numeric characters
                  setOtp((prevState) => ({
                    ...prevState,
                    mobile: numericValue,
                  }));
                  setOtpErrors((prevError) => ({
                    ...prevError,
                    mobile: '',
                  }));
                }}
                value={otp?.mobile}
                className={styles.formInput}
                placeholder="Enter OTP"
              />
              {otpErrors?.mobile && <div className={styles?.errorMsg}>{otpErrors?.mobile}</div>}
            </div>
            <div className={styles.btn} onClick={() => onVerifyClick('mobile')}>
              Verify
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default Account;
